import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
// @ts-ignore
import Link from 'next/link';
import styled from "styled-components";
import ImageWithFallback from '../ImageWithFallback';
import {IBrandCategory} from "../../interfaces/IBrandCategory";
import {getNavPath} from "../../shared/navigateUtil";
import {useRouter} from "next/router";
import {getTheme} from "../../shared/themeUtils";

const CategoriesContain = styled.div`
  background-color: #fff;
  padding: ${getTheme("space.2")};
  margin-right: -${getTheme("space.2")};
  max-width: 100%;

  ul {
    padding: 0;
    margin: 0;
  }

  li {
    list-style: none;
  }

  .cat-columns {
    padding: 0;

  }
  
  .title {
    position: relative;
    right: 12px
  }
`

const CategoryBox = styled.div`
  border: 1px solid ${getTheme("colors.border")};
  margin-right: ${getTheme("space.2")};
  margin-bottom: ${getTheme("space.2")};
  padding: ${getTheme("space.2")};
  border-radius: ${getTheme("borderRadius")};
  height: 80px;
  font-size: ${getTheme("fontSizes.small")};
  display: flex;
  font-weight: 500;
  cursor: pointer;

  .image-contain {
    display: flex;
    padding: 0;
    margin: 0;
    justify-content: center;
    align-items: center;
    position: relative;
    max-width: 80px;
    max-height: 100px;
  }

  .text-contain {
    display: flex;
    align-items: center;
    padding: 0;
    margin-left: ${getTheme("space.1")};
  }

  @media (max-width: ${getTheme("breakpoints.1")}) {
    height: 80px;
    margin-right: ${getTheme("space.0")};

    .image-contain {
      max-width: 100px;

      img {
        max-width: 60px;
        max-height: 60px;
      }
    }
  }
`

interface CategoriesProps {
  categories: IBrandCategory[],
  title?: string,
  backgroundColor?: string
}

const BrandCategories = (props: CategoriesProps) => {
  const router = useRouter()
  const categoriesList = props.categories.map((category: IBrandCategory) => {
    return (
      <Col key={category.categoryName} xl={4} md={6} className="cat-columns">
        <Link
          href={getNavPath(router, `cat/${category.categorySlug}?filter=${encodeURIComponent("brand=") + category.brandId}`)}>
          <CategoryBox>
            <Col className="image-contain">
              {category.categoryImageUrl &&
                <ImageWithFallback key={category.categoryId}
                                   alt={category.categoryName}
                                   src={category.categoryImageUrl}
                                   fallbackSrc={'/client-images/box-flat.png'}
                                   layout="fill"
                                   objectFit={"contain"}/>}
            </Col>
            <Col className="text-contain">
              <span>{category.categoryName}</span>
            </Col>
          </CategoryBox>
        </Link>
      </Col>
    );
  });

  const title = <h2 className={"fw-bold title"}>{props.title}</h2>

  return (
    <CategoriesContain>
      {props.title != null && title}
      <ul>
        <Row>
          {categoriesList}
        </Row>
      </ul>
    </CategoriesContain>
  )
}

export default BrandCategories;
